import Utils from "../helpers/utils";
const dom = {};

const init = (_) => {
    cacheDOM();
    bindEvents();
};

const cacheDOM = (_) => {
    dom.root = window.matchMedia("(max-width: 1124px)").matches
        ? document.querySelector("[data-mobile-search]")
        : document.querySelector("[data-search]");

    dom.input = dom.root.querySelector("[data-search-input]");
    dom.clearBtn = dom.root.querySelector("[data-search-clear]");
    dom.results = dom.root.querySelector("[data-search-results]");
    dom.mobileToggle = document.querySelector('[data-search-toggle]');
};

const bindEvents = (_) => {
    dom.input.addEventListener("input", Utils.debounce(find, 300));
    dom.input.addEventListener("focus", (_) => {
        dom.root.classList.add("on-focus");
    });
    dom.input.addEventListener("blur", (_) => {
        dom.root.classList.remove("on-focus");
    });
    dom.clearBtn.addEventListener("click", clear);
    dom.mobileToggle.addEventListener('click', _ => {
        dom.root.classList.toggle('is-visible')
    });
    document.addEventListener('click', e => {
        if (e.target.closest('[data-mobile-search]') || e.target.closest('[data-search-toggle]')) return;
        dom.root.classList.remove('is-visible')
    })
};

// const checkHistory = _ => {
// 	const history = localStorage.getItem('searchHistory') ? JSON.parse(localStorage.getItem('searchHistory')) : [];
// 	if (!history.length) return;
// 	dom.root.classList.add('has-history');
// 	dom.history.innerHTML = history.reduce((html, item) => (
// 		html += /*html*/`
// 		<button class="modal_search__link">
// 			<svg class="icon"><use xlink:href="#icon_search_history"></use></svg>
// 			<span class="modal_search__text">
// 				${item}
// 			</span>
// 		</button>
// 		`
// 	), '<p class="modal_search__title">Последние поисковые запросы</p>')
// }

const find = async (_) => {
    if (dom.input.value === "") {
        dom.root.classList.remove("has-results");
        checkHistory();
    }
    if (dom.input.value.length < 2) return;
    dom.root.classList.add("on-request");
    const req = await fetch(`/api/search?query=${dom.input.value}`);
    const res = await req.json();
    dom.root.classList.remove("on-request");
    renderResults(res);
};

// const save = _ => {
// 	const history = localStorage.getItem('searchHistory') ? JSON.parse(localStorage.getItem('searchHistory')) : [];
// 	history.length === 16 && history.shift();
// 	dom.input.value && history.push(dom.input.value);
// 	localStorage.setItem('searchHistory', JSON.stringify(history));
// }

const renderResults = (items) => {
    dom.root.classList.add("has-results");
    dom.root.classList.remove("has-history");
    if (!items.length) {
        dom.results.innerHTML = /*html*/ `
			<p class="header_search__title">Результаты поиска</p>
			<p class="header_search__text">По вашему запросу ничего не найдено.</p>`;
        return;
    }

    dom.results.innerHTML = items.reduce(
        (html, item) =>
            (html += /*html*/ `
        <a class="header_search_item" href="/catalog/new/${item.slug}">
            <img class="header_search_item__pic"
                src="${item.cover}" loading="lazy">
            <div class="header_search_item__text">
                <p class="header_search_item__name">${item.name}</p>
                <p class="header_search_item__address">${item.address}</p>
            </div>
        </a>
		`),
        `<p class="header_search__title">Результаты поиска</p>`
    );
};

// const handleHistoryClick = ( { target } ) => {
// 	const item = target.closest('.modal_search__link');
// 	if (!item) return;
// 	dom.input.value = item.querySelector('.modal_search__text').innerText;
// 	find();
// }

const clear = (_) => {
    dom.input.value = "";
    find();
};

export default {
    init,
};
